import { MdOutlineFileDownload } from "react-icons/md";
import "../styles.scss";

function ProfileItem(props: any) {
  const handleDownload = async () => {
    try {
      const response = await fetch(props?.value, { mode: "cors" });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const rawName = props?.name || props?.label || "file";
      const fileName = `${rawName.replace(/\s+/g, "").toLowerCase()}-deck`;
  
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  return (
    <div className="VcDetailsScreen-item">
      <div>{props?.icon}</div>
      <div>
        <div className="VcDetailsScreen-text3">{props?.label}</div>
        {props?.type === "link" ? (
          <div onClick={handleDownload} style={{cursor: "pointer"}}>
           <span className="VcDetailsScreen-text4">
              Download
            </span>
            <MdOutlineFileDownload
              size={20}
              color="#0026ab"
              style={{ marginLeft: 10 }}
              onClick={handleDownload}
            />
          </div>
        ) : (
          <div className="VcDetailsScreen-text4">{props?.value}</div>
        )}
      </div>
    </div>
  );
}

export default ProfileItem;
